__turbopack_context__.v({
  "secTextWrapper": "SectionLink-module-scss-module__QnsowG__secTextWrapper",
  "secTitleWrapper": "SectionLink-module-scss-module__QnsowG__secTitleWrapper",
});
